import { Controller } from "@hotwired/stimulus"

// Manages event dropdown menus on the calendar
export default class extends Controller {
  static targets = ["dropdown"]
  
  connect() {
    this.initializeDropdowns()
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }
  
  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }
  
  initializeDropdowns() {
    const eventItems = document.querySelectorAll('.event-item, [data-event-id]')
    eventItems.forEach(item => {
      const dropdown = item.querySelector('.event-dropdown')
      if (dropdown) {
        dropdown.dataset.eventId = item.dataset.eventId
      }
    })
  }
  
  toggle(event) {
    const eventItem = event.currentTarget.closest('.event-item')
    if (!eventItem) return
    
    event.preventDefault()
    event.stopPropagation()
    
    // Don't handle clicks on dropdown links/buttons
    if (event.target.closest('.event-dropdown, .arrival-dropdown, .pickup-dropdown')) {
      return
    }
    
    // Close other dropdowns
    this.closeOtherDropdowns(eventItem)
    
    // Toggle this dropdown
    const dropdown = eventItem.querySelector('.event-dropdown, .arrival-dropdown, .pickup-dropdown')
    if (!dropdown) return
    
    const wasHidden = dropdown.classList.contains('hidden')
    dropdown.classList.toggle('hidden')
    
    // Position dropdown
    if (!dropdown.classList.contains('hidden')) {
      this.positionDropdown(dropdown, event.target.closest('[data-event-type], [data-event-id]') || eventItem)
    }
  }
  
  closeOtherDropdowns(currentItem) {
    document.querySelectorAll('.event-dropdown, .arrival-dropdown, .pickup-dropdown').forEach(dropdown => {
      const currentDropdown = currentItem.querySelector('.event-dropdown, .arrival-dropdown, .pickup-dropdown')
      if (dropdown !== currentDropdown) {
        dropdown.classList.add('hidden')
      }
    })
  }
  
  positionDropdown(dropdown, clickableElement) {
    const globalContainer = document.getElementById('global-dropdown-container')
    if (!globalContainer) return
    
    const rect = clickableElement.getBoundingClientRect()
    
    // Move dropdown to global container
    globalContainer.appendChild(dropdown)
    
    // Position dropdown
    dropdown.style.position = 'fixed'
    dropdown.style.left = rect.left + 'px'
    dropdown.style.top = (rect.bottom + 2) + 'px'
    dropdown.style.zIndex = '999999'
    dropdown.style.pointerEvents = 'auto'
  }
  
  handleOutsideClick(event) {
    if (!event.target.closest('.event-item, [data-event-id]')) {
      this.closeAllDropdowns()
    }
  }
  
  closeAllDropdowns() {
    document.querySelectorAll('.event-dropdown, .arrival-dropdown, .pickup-dropdown').forEach(dropdown => {
      dropdown.classList.add('hidden')
    })
  }
  
  // Handle View Status button clicks
  viewStatus(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const dropdown = event.target.closest('.event-dropdown')
    if (!dropdown) return
    
    const eventId = dropdown.dataset.eventId
    if (!eventId) return
    
    const eventItem = document.querySelector(`[data-event-id="${eventId}"]`)
    if (!eventItem) return
    
    const eventName = eventItem.dataset.eventName
    const eventStatus = eventItem.dataset.eventStatus
    
    // Close dropdown and restore position
    this.restoreDropdown(dropdown, eventId)
    
    // Show status modal
    if (window.openStatusModal) {
      window.openStatusModal(eventId, eventStatus, '')
    }
  }
  
  restoreDropdown(dropdown, eventId) {
    dropdown.classList.add('hidden')
    
    const globalContainer = document.getElementById('global-dropdown-container')
    if (globalContainer && globalContainer.contains(dropdown)) {
      const originalEventItem = document.querySelector(`[data-event-id="${eventId}"]`)
      if (originalEventItem) {
        originalEventItem.appendChild(dropdown)
        dropdown.style.position = ''
        dropdown.style.left = ''
        dropdown.style.top = ''
        dropdown.style.zIndex = ''
      }
    }
  }
}

